<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="border-hr border-bottom"></div>
            </div>

            <div class="pt-2 text-center col-12">
                &copy; Next Venue {{ new Date().getFullYear() }} - v{{changelog[0].version}} - <a class="force" v-b-modal="'changelog-model'">Changelog</a> -
                <detail-help class="inline" :uid="'1'"/> -
                <a href="https://offertetool.statuspage.io" title="Status" class="underline" target="_blank">Status</a>
            </div>
        </div>

        <b-modal
				scrollable
                @shown="show"
                @hidden="$root.modelOpen = false"
                :no-close-on-backdrop="false"
                :lazy="true"
                :ref="'changelog-model'"
                :id="'changelog-model'"
                title="Changelog"
                size="xl">
            <div>
                <ul class="timeline">
                    <li v-for="release in changelog">
                        <div class="d-flex justify-content-between">
                            <div class="title">
                                <strong>Update v{{release.version}}</strong>
                            </div>
                            <div class="time text-muted">
                                <i>{{release.date}}</i>
                            </div>
                        </div>
                        <ul v-for="row in release.rows">
                            <li><span v-html="row"></span></li>
                        </ul>
                    </li>
                </ul>
                <ul class="timeline first">
                    <li>
                        <div class="d-flex justify-content-between">
                            <div class="title">
                                <strong>Installatie v 1.0.0</strong>
                            </div>
                            <div class="time text-muted">
                                <i>03-05-2018</i>
                            </div>
                        </div>
                        <ul>
                            <li>Initiële installatie</li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div slot="modal-footer" class="w-100">
                <button class="btn btn-light float-right" @click="hide">
                    Sluiten
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import detailHelp from "./leads/detailHelp";

    export default {
        components: {
            detailHelp
        },
        data() {
            return {
                changelog: [
					{
						version: '2.8.4',
						date: '06-08-2024',
						rows: [
							'Er is een probleem opgelost waarbij de locatie niet meer aan te passen was in de Offertetool.',
							'Er is een probleem opgelost waardoor in EasyParty vaak dubbele contactpersonen werden aangemaakt en het hele systeem vertraagde.',
							'Er is een tijdelijke oplossing toegepast in de Offertetool waardoor voor Hotel de Werelt Lunteren geen aanvragen meer ingestuurd kunnen worden met evenementtype \'Huwelijk\'.'
						]
					},
					{
						version: '2.8.3',
						date: '03-07-2024',
						rows: [
							'Er is een wijziging aangebracht in de frequentie van de achtergrondtaken, waardoor problemen met de koppeling tussen AFAS en EasyParty worden voorkomen.',
							'Er is een probleem opgelost waardoor bij sommige leads geen contactmomenten werden doorgezet naar EasyParty.'
						]
					},
					{
						version: '2.8.2',
						date: '21-06-2024',
						rows: [
							'Er is een functionaliteit toegevoegd waarbij gebruikers van Mijn Next Venue bij het toevoegen van extra contactpersonen deze personen ook direct kunnen uitnodigen voor Mijn Next Venue. Zo kunnen collega\'s binnen een organisatie dus samenwerken aan aanvragen, maar kunnen bijvoorbeeld ook evenementenbureaus of weddingplanners hun klanten laten meekijken/werken.',
							'Er is een probleem opgelost waarbij de Offertetool niet goed opende wanneer er al een \'#\' aanwezig was in de URL.'
						]
					},
					{
						version: '2.8.1',
						date: '20-06-2024',
						rows: [
							'Er is een probleem verholpen waarbij het telefoonnummer van een contactpersoon niet kon worden bijgewerkt in Mijn Next Venue.',
							'In de Offertetool heeft de omzetgarantiecheck een nieuwe weergave gekregen waarbij een kalenderweergave wordt getoond waarin per dag met kleur is aangegeven wat het minimale omzetbedrag is. Tevens kan er direct voor een alternatieve datum worden gekozen vanuit deze weergave.',
							'In de Offertetool heeft de groene knop in de zijbalk een dynamische functie gekregen in het overzicht. Deze knop navigeert in eerste instantie (via een automatische scroll-beweging) naar het formulier om gegevens in te vullen. Zodra alle gegevens valide zijn ingevuld, wijzigt de functionaliteit achter deze knop naar een \'instuur\'-functie wanneer er nogmaals op geklikt wordt. Dit is gedaan om verwarring rondom deze knop in het verleden te voorkomen.',
							'De styling van de Ref.code in de header is geoptimaliseerd zodat duidelijker is dat deze code met één klik gekopieerd kan worden.',
							'Bij het insturen van een Offertetool-aanvraag blijft de pop-up nu in beeld met een laadwiel waardoor de gebruiker duidelijk doorheeft dat de aanvraag op dat moment verstuurd wordt.',
							'Er is een probleem verholpen in Mijn Next Venue waarbij de \'Terug\'-knop op de accountpagina niet goed functioneerde.',
							'De URL van de algemene voorwaarden is aangepast.',
							'In de Offertetool is een probleem verholpen waarbij wijzigingen van het aantal personen in stap 5 niet werden opgeslagen.',
							'Er is een probleem verholpen in Mijn Next Venue waarbij er onterecht bij het aanmaken van een nieuwe aanvraag werd gevraagd om verder te werken aan een voorgaande aanvraag, ook al was deze reeds afgerond.'
						]
					},
                    {
                        version: '2.8.0',
                        date: '19-06-2024',
                        rows: [
                            'Het is vanaf heden mogelijk dat één Mijn Next Venue-gebruiker gekoppeld is aan meerdere organisaties en/of personen.',
                            'Mijn Next Venue-gebruikers zien nu alle offerteaanvragen van de organisaties en/of personen waaraan zij gekoppeld zijn.',
                            'De functie om vanuit Mijn Next Venue een nieuwe aanvraag in te dienen is weer hersteld.',
                            'Bij het aanmaken van een nieuwe aanvraag vanuit Mijn Next Venue is een pop-up toegevoegd waarin gekozen kan worden voor welke organisatie of persoon de nieuwe aanvraag betreft. Er kan hier gekozen worden uit alle organisaties of personen waaraan deze Mijn Next Venue-gebruiker gekoppeld is.',
                            'Bij het aanmaken van een nieuwe aanvraag is een functie toegevoegd waarmee de aanvraag aangemaakt kan worden voor een nieuwe organisatie of persoon. In het geval dat de aanvraag met een alternatief e-mailadres wordt ingevuld, zal de aanvraag aan zowel dat betreffende e-mailadres worden gekoppeld als aan de Mijn Next Venue-gebruiker die de aanvraag heeft geïnitieerd.',
                            'In Mijn Next Venue is het vanaf nu mogelijk om gegevens voor alle gekoppelde organisaties/personen aan te passen.',
                            'Er is een probleem opgelost waarbij een particuliere aanvraag, ingediend met het e-mailadres van een reeds bestaande zakelijke gebruiker, onterecht aan deze organisatie werd gekoppeld.'
                        ]
                    },
                    {
                        version: '2.7.6',
                        date: '10-06-2024',
                        rows: [
                            'De API is aangepast waarbij informatie omtrent omzetgarantie nu efficiënter wordt aangeleverd.',
                            'Er is een aanpassing doorgevoerd in de API waarbij de omzetgarantiecheck op een betrouwbaardere manier wordt uitgevoerd.',
                            'Er is een probleem opgelost waarbij in sommige gevallen het totaalbedrag onjuist werd berekend tijdens de omzetgarantiecheck.'
                        ]
                    },
                    {
						version: '2.7.5',
						date: '31-05-2024',
						rows: [
                            'Er is een probleem opgelost waarbij de omzetgarantie in sommige gevallen een onjuist resultaat teruggaf.',
                            'Er zijn extra logs toegevoegd ten behoeve van de synchronisatie.',
                            'De tekst bij het automatisch toegevoegde programmaonderdeel is aangepast.'
						]
					},
					{
						version: '2.7.4',
						date: '29-05-2024',
						rows: [
							'Er zijn aanvullende technische logs aangebracht om eventuele synchronisatieproblemen beter te kunnen achterhalen.',
							'Geannuleerde evenementen zijn inhoudelijk niet langer zichtbaar door een toegevoegde pop-up.',
							'Geannuleerde aanvragen zijn inhoudelijk niet langer zichtbaar door een toegevoegde pop-up en zijn hierdoor niet meer te boeken en/of te bewerken.',
							'De tekst in de pop-up \'Bevestig offerteaanvraag\' is aangepast.',
							'Er is een probleem opgelost waarbij de browser onterecht na het afronden van een offerteaanvraag waarschuwde voor het verlies van gegevens bij het verlaten van de pagina.'
						]
					},
					{
						version: '2.7.3',
						date: '28-05-2024',
						rows: [
                            'Er is een probleem opgelost waarbij de update rondom het verbeteren van de vormgeving en het uitbreiden van de opties enkel was toegepast voor NV-leads. Met deze update geldt dit nu ook voor reguliere leads.',
                            'Er is een probleem opgelost waarbij ten onrechte beschikbaarheid werd aangegeven voor een datum waarop reeds een partij aanwezig was, waarvan de eindtijd na middernacht lag.',
                            'Er is een probleem opgelost waarbij de reservering placeholder in EasyParty onjuist werd aangemaakt indien de eindtijd van de partij na middernacht lag.',
                            'Er is een probleem opgelost waarbij de \'Selecteer\' knop verborgen was bij het kiezen van een organisatie voor een nieuwe NV-lead.'
						]
					},
                    {
                        version: '2.7.2',
                        date: '27-05-2024',
                        rows: [
                            'De vormgeving en werking voor het doorsturen van een lead is verbeterd.',
                            'Er is een functie toegevoegd om een lead door te kunnen sturen naar De Werelt Lunteren.',
                            'Er is een functie toegevoegd om een lead door te kunnen sturen naar De Werelt Garderen.',
                            'In de weergave van een NV-lead is een automatische controle toegevoegd waarbij gecontroleerd wordt of de aangevraagde locatie (in combinatie met eventuele zalen) beschikbaar is.'
                        ]
                    },
                    {
                        version: '2.7.1',
                        date: '24-05-2024',
                        rows: [
                            'De NV-referentiecode is nu klikbaar in de Offertetool, waarbij de NV-referentiecode naar het klembord gekopieerd zal worden.',
							'Wanneer een NV-lead omgezet wordt naar een EP-aanvraag, worden nu ook de gekozen zalen toegevoegd aan het programma.',
							'Er is een probleem opgelost waarbij de beschikbaarheidscheck onjuist functioneerde wanneer de eindtijd na middernacht lag.',
							'Er is een probleem opgelost waarbij de uiterste te kiezen eindtijd in Mijn Next Venue altijd een half uur eerder was dan in de Offertetool.'
                        ]
                    },
                    {
                        version: '2.7.0',
                        date: '23-05-2024',
                        rows: [
                            'De beschikbaarheidscheck is verwijderd uit de Offertetool en komt nu alleen nog binnen Mijn Next Venue voor. Zo worden leads niet al aan de voorkant afgeweerd, maar kan er via een NV-lead samen met de contactpersoon gezocht worden naar een alternatieve datum of locatie.',
                            'De beschikbaarheidscheck van de locatie/zalen wordt niet langer apart in AFAS-agenda\'s bijgehouden, maar controleert nu rechtstreeks in de agenda van EasyParty.',
                            'De omzetgarantie wordt niet langer in AFAS opgeslagen, maar in de database van de Next Venue API. Per dag (ma, di, woe, enz.) kan er per locatie een standaard te behalen omzetbedrag worden ingevoerd.',
                            'Het is mogelijk om (nu nog via de database) rechtstreeks bepaalde data die bijvoorbeeld (on)populair zijn te overrulen met een afwijkend bedrag voor een specifieke datum.'
                        ]
                    },
                    {
                        version: '2.6.2',
                        date: '09-04-2024',
                        rows: [
                            'Er is een probleem opgelost waarbij de verwerking van de AFAS > EasyParty-synchronisatie extreem lang kon duren.'
                        ]
                    },
                    {
                        version: '2.6.1',
                        date: '25-03-2024',
                        rows: [
                            'Bij een NV-lead wordt vanaf heden automatisch een systeem-contactmoment toegevoegd met dezelfde URL die de klant ontvangt om een account aan te maken. Zo kan deze URL eventueel opnieuw worden doorgegeven wanneer de klant de e-mail niet meer kan vinden.',
                            'In \'Mijn Next Venue\' is het nu mogelijk om een aanhef op te geven. Op basis van de aanhef wordt in AFAS en EasyParty nu ook het geslacht van de contactpersoon gesynchroniseerd.',
                            'In de \'Leadbox\' is het vanaf nu mogelijk om bij de contactgegevens een tussenvoegsel op te geven.',
                            'In de \'Leadbox\' is vanwege het gebruiksgemak de keuze in de aahef vereenvoudigd en samengevoegd met het geslacht.',
                            'Er is een probleem opgelost waarbij het tussenvoegsel niet goed gesynchroniseerd werd van AFAS naar EasyParty.',
                            'Er is een probleem opgelost waarbij de TTR-timer (Time To Respond) buiten kantoortijden (visueel) nog steeds aftelde.',
                            'In \'Mijn Next Venue\' zijn diverse kleine visuele verbeteringen doorgevoerd.'
                        ]
                    },
                    {
                        version: '2.6.0',
                        date: '18-03-2024',
                        rows: [
                            'Meerdaagse evenementen worden nu in EasyParty als één evenement aangemaakt. Daarnaast worden de geselecteerde zalen automatisch aan het programma gekoppeld.',
                            'In de \'Offertetool\' is de optie om meerdere dagen op te geven verplaatst naar stap 2.'
                        ]
                    },
                    {
                        version: '2.5.14',
                        date: '11-03-2024',
                        rows: [
                            'Er is een quick-fix toegepast waarmee tijdelijk het probleem is verholpen waarbij leads die al als spam waren gemarkeerd toch weer als "open" werden weergegeven.'
                        ]
                    },
                    {
                        version: '2.5.13',
                        date: '11-03-2024',
                        rows: [
                            'De TTR-timer (Time To Respond) is ook toegevoegd aan NV-leads.',
                            'De TTR-timer (Time To Respond) telt voortaan alleen nog af tijdens kantooruren.',
                            'In \'Mijn Next Venue\' is voortaan een verlopen, geboekte, overgenomen of geannuleerde evenement niet meer inhoudelijk in te zien. Er verschijnt een pop-up met een passende uitleg waarom de aanvraag niet meer te openen is.',
                            'Er is een verbetering toegepast in de API-koppeling met EasyParty, waarbij nu geen onnodige tijdstippen meer worden meegegeven aan datumvelden. Dit betreft een technische verbetering en heeft verder geen effect op het gebruik.',
                            'Vanaf heden wordt voor zowel de staging- als productieomgeving één GTM-ID (Google Tag Manager) met gescheiden omgevingen gebruikt, in plaats van twee afzonderlijke GTM-ID\'s.',
                            'Er is alleen-lezen ondersteuning toegevoegd aan het veld voor het inkoopnummer.'
                        ]
                    },
                    {
						version: '2.5.12',
						date: '06-03-2024',
						rows: [
							'Er zijn diverse verbeteringen toegepast ter voorkoming van dubbele organisaties in EasyParty.',
							'Er zijn diverse verbeteringen toegepast ter voorkoming van dubbele contactpersonen in EasyParty.'
						]
					},
					{
						version: '2.5.11',
						date: '13-02-2024',
						rows: [
							'Een bug is verholpen waarbij het telefoonnummer onterecht als ongeldig werd gemarkeerd.',
							'Vanaf heden zoekt de zoekmachine standaard zonder rekening te houden met de ingestelde filters. Dit is te zien doordat de ingestelde filters inactief worden weergegeven.',
							'Er is een nieuwe knop toegevoegd naast het zoekveld (knop met een filtersymbool) waarmee het mogelijk is om te zoeken in combinatie met de ingestelde filters.',
							'Bij het verwijderen van een eerder ingevoerde zoekterm worden vanaf heden de resultaten direct vernieuwd.',
							'Er zijn extra signalen ingebouwd die onder andere via e-mail waarschuwen wanneer er iets misgaat tijdens het importeren van een lead in EasyParty.',
							'Er is een bug opgelost waarbij het mogelijk was om meerdere geslachten te selecteren bij het toevoegen/bewerken van een contactpersoon.'
						]
					},
                    {
                        version: '2.5.10',
                        date: '01-02-2024',
                        rows: [
                            'Er is een probleem opgelost in de beschikbaarheids- / omzetcheck, waarbij ten onrechte dagen als niet beschikbaar werden gemarkeerd op basis van een te lage omzet.',
                            'Er is een probleem opgelost waarbij in sommige gevallen een partijdatum met een dag verschil werd geïmporteerd in EasyParty.'
                        ]
                    },
                    {
                        version: '2.5.9',
                        date: '01-02-2024',
                        rows: [
                            'Er is een probleem opgelost waarbij leads niet konden worden doorgestuurd naar EasyParty wanneer er geen specifieke op- en/of afbouwdag was opgegeven.'
                        ]
                    },
                    {
                        version: '2.5.8',
                        date: '30-01-2024',
                        rows: [
                            'Bij het selecteren van een bestaand contactpersoon in het CRM is een controle toegevoegd die controleert of alle benodigde velden zijn gevuld. Indien dit niet het geval is, wordt een pop-up getoond waar de benodigde gegevens kunnen worden aangevuld.',
                            'Er is een mogelijkheid toegevoegd om een foutief gekoppeld contactpersoon (bijv. door problemen met de koppeling naar EasyParty) alsnog achteraf te koppelen.',
                            'Er is een validatie toegevoegd die controleert of een organisatie en contactpersoon goed gekoppeld zijn voordat de lead doorgezet kan worden naar EasyParty.',
                            'In de weergave is een fout opgelost waardoor in sommige gevallen een tussenvoegsel van de achternaam niet zichtbaar was.'
                        ]
                    },
					{
						version: '2.5.7',
						date: '25-01-2024',
						rows: [
							'Bij het klikken op een filter wordt voortaan automatisch de cursor in het zoekveld geplaatst.',
							'Er is een zoekoptie toegevoegd aan het \'Bronnen\'-filter.',
							'Bij het selecteren van een bestaande organisatie in het CRM is een controle toegevoegd die controleert of er een adres is gekoppeld. Indien dit niet het geval is, wordt een pop-up getoond waar de benodigde gegevens kunnen worden aangevuld.',
							'Onderin de leadbox is een link \'<a href="https://offertetool.statuspage.io/" target="_blank" title="Status">Status</a>\' toegevoegd waarmee naar een <a href="https://offertetool.statuspage.io/" target="_blank" title="Status">statuspagina</a> genavigeerd kan worden. Op die pagina is de status van ieder systeem terug te vinden en worden grootschalige incidenten gerapporteerd die invloed hebben op de algehele werking van de tools. Ook wordt hier de mogelijkheid geboden om per e-mail op de hoogte gesteld te worden van updates over incidenten.',
							'De link waarmee de gebruiker een \'Mijn Next Venue\'-account kan aanmaken, blijft voortaan 60 dagen geldig, in plaats van de vorige 48 uur.',
							'Er is een technische aanpassing doorgevoerd om te voorkomen dat een boeking wel binnen \'Mijn Next Venue\' wordt verwerkt, maar niet wordt doorgezet naar EasyParty.'
						]
					},
                    {
                        version: '2.5.6',
                        date: '12-01-2024',
                        rows: [
                            'Standaard voorkeurwaarden zijn nu per locatie worden waardoor een evenement al vollediger aangemaakt zal worden in EasyParty. Dit gaat o.a. om de juiste prijslijsten, kostenplaats, administratie en label.',
                            'Vanwege langdurige problemen met de \'Nieuw samenstellen\' functie in Mijn Next Venue is de knop hiervoor tijdelijk verborgen tot de problemen in een latere update opgelost worden.',
                            'Er is een striktere beveiliging doorgevoerd voor een technisch beheerdersconsole.'
                        ]
                    },
                    {
                        version: '2.5.5',
                        date: '10-01-2024',
                        rows: [
                            'Er is een probleem opgelost waardoor een NV-lead bij het openen in eerste instantie niet als \'Gelezen\' werd gemarkeerd.',
                            'Er is een probleem opgelost waardoor de kostenplaats bij sommige locaties niet goed door kwam naar EasyParty.',
                            'Leads die vanuit \'Mijn Next Venue\' worden aangemaakt worden nu ook geregistreerd met als bron \'Mijn Next Venue\'.',
                            'Er is een voorbereiding gedaan om in een latere update standaard voorkeurwaarden per locatie op te kunnen slaan.'
                        ]
                    },
                    {
                        version: '2.5.4',
                        date: '09-01-2024',
                        rows: [
                            'Het is niet langer mogelijk handmatig een evenement aan te maken in EasyParty (met uitzondering van specifieke gebruikers)',
                            'Er is een probleem verholpen waarbij er binnnen een NV-lead een inlogscherm te zien was in plaats van de aanvraag binnen de Mijn Next Venue omgeving.',
                            'De notificatie per e-mail is verwijderd wanneer een lead was gekoppeld. Deze notificatie is overbodig geworden nu dit ook als actie binnen EasyParty aangemaakt wordt.',
                            'De uitlijning van de locatieafbeelding is verbeterd in het meerdaags overzicht van de Mijn Next Venue omgeving.',
                            'De weergave van de titel tijdens het aanmaken van een NV-lead is verbeterd.'
                        ]
                    },
                    {
                        version: '2.5.3',
                        date: '04-01-2024',
                        rows: [
                            'Vanaf deze update wordt standaard de aan de lead toegewezen accountmanger gebruikt bij het importeren in EasyParty. Bij het handmatig \'Doorzetten naar EasyParty\' is de pop-up met de keuze voor een accountmanager dan ook komen te vervallen.'
                        ]
                    },
                    {
                        version: '2.5.2',
                        date: '03-01-2024',
                        rows: [
                        'Er is een probleem opgelost waarbij de bron van NV-leads vanaf bepaalde websites niet goed werd geregistreerd.',
                        'De NV-referentiecode is nu op de leaddetailpagina ook als titel vermeld.',
                        'Er is een probleem verholpen waarbij de evenementdatum niet juist werd overgenomen naar EasyParty.',
                        'De omschrijving van een evenement in EasyParty is voortaan altijd de NV-referentiecode.'
                        ]
                    },
                    {
                        version: '2.5.1',
                        date: '02-01-2024',
                        rows: [
                            'Er is een probleem opgelost waardoor een NV-lead aangemaakt kon worden zonder contactpersoon.',
                            'Er is een probleem opgelost waardoor de ‘Omzetten naar NV-lead’ knop zichtbaar was bij reeds gearchiveerde leads.',
                            'Bij het starten van de Offertetool is een verwijzing naar de privacy policy en de voorwaarden toegevoegd.'
                        ]
                    },
					{
						version: '2.5.0',
						date: '22-12-2023',
						rows: [
							'Het voormalige \'Leads\' dashboard is hernoemd naar \'Leadbox\'.',
							'Leads worden standaard geïmporteerd in EasyParty onder de administratie \'NextVenue B.V.\'.',
							'Leads worden standaard geïmporteerd in EasyParty met het label \'NextVenue B.V.\'.',
							'Het \'AFAS ContactID\' wordt nu automatisch gevuld bij een contactpersoon in EasyParty.',
							'De labels en symbolen bij contactmomenten zijn hersteld.',
							'Het logo is bijgewerkt in de in de automatisch gegenereerde lead PDF.',
							'Er is een nieuwe status \'Offertetraject\' toegevoegd.',
							'Er is een knop in de detailweergave voor een NV-lead toegevoegd om de status te wijzigen naar \'Offertetraject\'.',
							'Er is een filteroptie toegevoegd om te kunnen filteren op \'Offertetraject\'.',
							'Er is een probleem verholpen waarbij de verkeerde vlag getoond werd bij een invoerveld voor een telefoonnummer.',
							'De auto-complete functionaliteit bij het invoeren van een organisatie en contactpersoon is (tijdelijk) verwijderd in verband met problemen.',
							'Er is ondersteuning voor NV-leads toegevoegd.',
							'Er is een nieuwe knop aan het overzicht toegevoegd om een NV-lead handmatig toe te voegen.',
							'Er is een nieuwe weergave toegevoegd voor een NV-lead waarbij in een venster direct de gekoppelde \'Offertetool\' of de \'Mijn Next Venue\' omgeving te zien is.',
							'Er is een functionaliteit toegevoegd waarbij een NV-lead overgenomen kan worden in EasyParty. Daarbij sluit de \'Offertetool\' en \'Mijn Next Venue\' omgeving voor de klant automatisch.',
							'Afgeronde Offertetool-trajecten worden automatisch aangemaakt als NV-lead.',
							'Er is een \'X\' logo toegevoegd in het overzicht ter herkenning van NV-leads.',
							'Er wordt automatisch een EasyParty actie aangemaakt zodra een klant een NV-lead boekt vanuit de \'Mijn Next Venue\' omgeving.',
							'Er wordt automatisch een e-mail verstuurd naar de klant zodra er een NV-lead is aangemaakt met een uitnodiging naar de \'Offertetool\'.',
							'Er wordt automatisch een e-mail verstuurd naar de klant zodra het NV-lead wordt overgenomen in EasyParty en niet langer beheerd kan worden in de \'Offertetool\' of \'Mijn Next Venue\'.',
							'Er is een wijziging doorgevoerd waarbij er in de \'Offertetool\' niet om de klantgegevens gevraagd zal worden indien het traject door een accountmanager als NV-lead is aangemaakt.',
							'Er is een knop toegevoegd waarbij een reguliere lead kan worden omgezet naar een NV-lead. Hierbij zullen de velden \'Locatie\', \'Aantal gasten\', \'Aard\' en \'Evenementsdatum\' worden meegenomen in de \'Offertetool\'.',
							'Het veld \'Evenementdatum\' is hernoemd naar \'Evenementsdatum\'.',
							'Een organisatie wordt nu direct als verkooprelatie aangemaakt in AFAS.',
							'De inhoud van een contactmoment wordt voortaan in het onderwerp al deels weergeven ten behoeve van de herkenbaarheid.',
							'Een ingelogde of uitgenodigde gebruiker kan in de Offertetool alleen nog evenement types selecteren op basis van het type relatie (particulier/zakelijk).'
						]
					},
                    {
                        version: '2.0.0',
                        date: '11-10-2019',
                        rows: [
                            'Sneltoetsen toegevoegd (terug te vinden onder \'Help\'',
                            'De status \'In afwachting\' is toegevoegd',
                            'Een actiebutton is toegevoegd om een lead direct \'Ín afwachting\' te zetten',
                            'Bij het toevoegen van een contactmoment kan de lead met één klik \'Ín afwachting\' worden gezet',
                            'Na het selecteren van een organisatie opent nu automatisch direct de pop-up om een contactpersoon te selecteren',
                            'De lead status is visueel duidelijker met standaard kleuren zichtbaar gemaakt',
                            'De weergave van contactmomenten is verbeterd',
                            'De weergave van actieve filters is verbeterd waardoor deze overzichtelijker zijn en makkelijker te wissen zijn',
                            'Onderaan het dashboard is een footer toegevoegd waar de \'Changelog\' en de \'Help\' pop-up geopend kunnen worden',
                            'De indeling van velden is geoptimaliseerd',
                            'Er wordt geen standaard aantal van \'50\' gasten meer ingevoerd bij nieuwe leads',
                            'Velden \'groeien\' automatisch mee in hoogte',
                            'Meldingen worden nu bovenaan in het midden getoond zodat dit een klik op de actieknoppen niet langer blokeert',
                            'Diverse pop-ups worden groter weergeven',
                            'Diverse elementen zoals velden en keuzemenu\'s zijn visueel geoptimaliseerd'
                        ]
                    },
                    {
                        version: '1.3.0',
                        date: '16-08-2019',
                        rows: [
                            'Er wordt nu automatisch een PDF gegenereerd na het importeren in EP om alle informatie over de lead terug te vinden',
                            'Externe lead generatie websites worden nu als aparte bron herkend'
                        ]
                    },
                    {
                        version: '1.2.0',
                        date: '02-01-2019',
                        rows: [
                            'Er is nu een automatische gebruikerskoppeling met AFAS',
                            'Verplichte velden zijn herkenbaar gemaakt met een \'*\' symbool',
                            'De aard van een lead wordt nu automatisch voorgeselecteerd o.b.v. het type organisatie',
                            'E-mails naar leads@tekagroep.nl worden vanaf nu automatisch als lead aangemaakt'
                        ]
                    },
                    {
                        version: '1.1.0',
                        date: '26-10-2018',
                        rows: [
                            'Timers zijn aan leads toegevoegd',
                            'Het is nu mogelijk leads tussentijds op te slaan',
                            'De formulieren zij zo veel mogelijk gelijk getrokken (handmatig vs. binnenkomende leads)',
                            'De optie \'Doorsturen naar keuken\' is verwijderd',
                            'De optie \'Verwijderen\' is verwijderd'
                        ]
                    }
                ],
            }
        },
        methods: {
            hide() {
                this.$refs['changelog-model'].hide();
            },
            show(model) {
                this.$root.modelOpen = model.target.id;
            },
        }
    }
</script>

<style scoped>
    .timeline.first::before {
        display: none;
    }

    .inline {
        display: inline;
    }

    .underline {
        text-decoration: underline;
    }
</style>